import styles from "./ScheduleLegend.module.css"

function ScheduleLegend() {
  return (
    <div className={styles.container}>
      <blockquote className={styles.freeform}>
        <p>Freeform</p>
      </blockquote>
      <blockquote className={styles.specialty}>
        <p>Specialty</p>
      </blockquote>
      <blockquote className={styles.cp}>
        <p>Community Programming</p>
      </blockquote>
    </div>
  );
}

export default ScheduleLegend;
